import * as React from "react";
import { noop } from "lodash";

import ListOptionGroup from "../../_organism/ListOptionGroup";

import {
  RGContainer,
  RGHeader,
  RGHeaderContent,
  RGTitle,
  RGDescription,
  RGMain,
  RGNavbar,
  RGContent,
  ContainerFooter,
  FooterTitle
} from "./styled-components";

const listItemToOptions = (list) =>
  list.map((item) => ({
    id: item.id,
    title: item.title
  }));

const buildListOptionGroup = (
  userLimitsOptionsTitle,
  userLimitsOptions,
  timeOutExclusionsTitle,
  timeOutExclusions
) => {
  const userLimitsOptionGroup = {
    groupId: 1,
    groupTitle: userLimitsOptionsTitle,
    options: listItemToOptions(userLimitsOptions)
  };

  const timeoutExclusionsOptionGroup = {
    groupId: 2,
    groupTitle: timeOutExclusionsTitle,
    options: listItemToOptions(timeOutExclusions)
  };

  return [userLimitsOptionGroup, timeoutExclusionsOptionGroup];
};

export default function ResponsibleGamingSideMenu({
  qaLabel,
  title,
  description,
  userLimitsOptionsTitle,
  userLimitsOptions,
  timeOutExclusionsTitle,
  timeOutExclusions,
  optionSelected,
  optionSelectedHandler,
  WagerResponsiblyTitle,
  WagerResponsibly,
  children
}) {
  return (
    <RGContainer data-qa-label={qaLabel}>
      <RGHeader>
        <RGHeaderContent>
          <RGTitle data-qa-label={`${qaLabel}-title`}>{title}</RGTitle>
          <RGDescription data-qa-label={`${qaLabel}-description`}>
            {description}
          </RGDescription>
        </RGHeaderContent>
      </RGHeader>
      <RGMain>
        <RGNavbar data-qa-label={`${qaLabel}-navbar`}>
          <ListOptionGroup
            listOptionGroup={buildListOptionGroup(
              userLimitsOptionsTitle,
              userLimitsOptions,
              timeOutExclusionsTitle,
              timeOutExclusions
            )}
            optionSelected={optionSelected}
            optionSelectedHandler={optionSelectedHandler}
          />
        </RGNavbar>
        <RGContent data-qa-label={`${qaLabel}-content`}>
          {children}
          <ContainerFooter>
            <FooterTitle>{WagerResponsiblyTitle}</FooterTitle>
            {WagerResponsibly}
          </ContainerFooter>
        </RGContent>
      </RGMain>
    </RGContainer>
  );
}

ResponsibleGamingSideMenu.defaultProps = {
  qaLabel: "RGTemplate",
  title: "",
  description: "",
  userLimitsOptionsTitle: "",
  userLimitsOptions: [],
  timeOutExclusionsTitle: "",
  timeOutExclusions: [],
  optionSelected: null,
  optionSelectedHandler: noop,
  WagerResponsiblyTitle: "",
  WagerResponsibly: <React.Fragment />,
  children: null
};
